<script setup>
import { useI18n } from 'vue-i18n'
import { findIndexByParam } from '@/utils/findByParam'
import FormCheckbox from '@/components/form/FormCheckbox.vue'

const props = defineProps({
  lists: Array,
  disabled: Boolean,
  attributes: Object,
})

const { locale } = useI18n()
const emit = defineEmits(['update'])

function updateList(list, value) {
  const index = findIndexByParam(props.lists, 'id', list.id)
  const updatedLists = [...props.lists]

  updatedLists[index].subscribed = value

  emit('update', updatedLists)
}

function getTranslationAttr(list, attr) {
  if (list.translations) {
    let translation = list.translations.filter((translation) => translation.language === locale.value)
    if (translation.length === 1) {
      return translation[0][attr]
    }
  }

  return list[attr]
}

function getValue(list) {
  return list.subscribed !== undefined ? list.subscribed : list.subscription_default_state
}
</script>

<template>
  <div :class="attributes?.layout_density !== 'comfortable' ? 'mx-6 pt-2' : 'mx-6'">
    <template v-for="list in lists" :key="list.createId || list.id">
      <div v-if="list.type === 'separator'" :class="attributes?.layout_density === 'comfortable' ? 'mt-2' : ''">
        <p
          v-if="list.label || list.icon"
          class="text-xs uppercase tracking-widest mb-0.5 flex items-center gap-1"
          :class="{
            'font-semibold text-gray-400': !list.text_style || list.text_style === 'bold',
            'font-normal text-gray-400': list.text_style === 'normal',
            'font-normal text-gray-300': list.text_style === 'muted',
          }"
        >
          <span v-if="list.icon" class="material-symbols-outlined text-sm" :style="{ color: list.icon_color || '#6b7280' }">{{ list.icon }}</span>
          {{ list.label }}
        </p>
        <hr
          :class="attributes?.layout_density === 'comfortable' ? 'border-t border-gray-200' : 'border-t border-gray-100'"
          :style="list.separator_color ? { borderColor: list.separator_color } : {}"
        />
      </div>
      <div
        v-else
        class="cursor-pointer"
        :class="attributes?.layout_density === 'comfortable' ? 'py-3' : 'py-2'"
        @click="!disabled ? updateList(list, !getValue(list)) : null"
      >
        <div class="flex items-start gap-3">
          <div class="pt-0.5">
            <FormCheckbox :value="getValue(list)" :disabled="disabled" :attributes="props.attributes" @input="(val) => updateList(list, val)" />
          </div>
          <div class="flex-1 min-w-0">
            <div class="flex items-center gap-2">
              <span v-if="list.attrs?.icon" class="material-symbols-outlined text-lg" :style="{ color: list.attrs?.icon_color || attributes?.primary_color }">{{
                list.attrs?.icon
              }}</span>
              <h3 class="text-base font-medium text-gray-900">{{ getTranslationAttr(list, 'name') }}</h3>
            </div>
            <p v-if="getTranslationAttr(list, 'description')" class="text-sm text-gray-500 mt-1">{{ getTranslationAttr(list, 'description') }}</p>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>
